import { ISettings } from "@fluentui/react";
import { models } from "powerbi-client";
import React from "react";
import { Stack, Theme } from "sprint-common-web";

import { PowerBIReport } from "../common/PowerBIReport";

export const MaterialOrderReportDashboard = (): JSX.Element => {
    return (
        <Stack
            styles={{
                root: {
                    height: "calc(100vh - 50px)",
                    marginLeft: -30,
                    marginRight: -30,
                    borderLeft: `1px solid ${Theme.palette.neutralQuaternary}`,
                    display: "flex"
                }
            }}
        >
            <PowerBIReport settings={materialOrderReportSettings} />
        </Stack>
    );
};

const materialOrderReportSettings: ISettings = {
    customLayout: {
        displayOption: models.DisplayOption.FitToPage
    },
    background: models.BackgroundType.Default,
    panes: {
        filters: { visible: true },
        pageNavigation: {
            visible: true,
            position: models.PageNavigationPosition.Left
        }
    }
};
